import './App.css';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Header from './components/Header';
import Home from './Pages/Home';
import Contact from './Pages/Contact';
import Projects from './Pages/Projects';
import About from './Pages/About';
import Studio from './Pages/Studio';
import Dubai from './Pages/Dubai';
import CorporateSocialResponsibility from './Pages/CorporateSocialResponsibility';
import Careers from './Pages/Careers';
import LifeAtAD from './Pages/LifeAtAD';
import EarlyCareers from './Pages/EarlyCareers';
import Benefits from './Pages/Benefits';
import Vacancies from './Pages/Vacancies';
import EquityDiversityInclusion from './Pages/EquityDiversityInclusion';
import Expertise from './Pages/Expertise';
import Architecture from './Pages/Architecture';
import ClimateSustainableDesign from './Pages/ClimateSustainableDesign';
import Engineering from './Pages/Engineering';
import Interiors from './Pages/Interiors';
import IndustrialDesign from './Pages/IndustrialDesign';
import UrbanAndLandscapeDesign from './Pages/UrbanAndLandscapeDesign';
import WorkplaceConsultancy from './Pages/WorkplaceConsultancy';
import Project1 from './Projects/Project1';
import People from './Pages/People';
import Footer from './components/Footer';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Header />
        <Routes>
          <Route path='/' element={<Home />} />
          <Route path='/studio' element={<Studio />} />
          <Route path='/studio/about' element={<About />} />
          <Route path='/studio/corporate-social-responsibility' element={<CorporateSocialResponsibility />} />
          <Route path='/studio/dubai' element={<Dubai />} />

          <Route path='/careers' element={<Careers />} />
          <Route path='/careers/life-at-architetive-designs' element={<LifeAtAD />} />
          <Route path='/careers/early-careers' element={<EarlyCareers />} />
          <Route path='/careers/benefits' element={<Benefits />} />
          <Route path='/careers/vacancies' element={<Vacancies />} />

          <Route path='/people/equity-diversity-and-inclusion' element={<EquityDiversityInclusion />} />

          <Route path='/expertise' element={<Expertise />} />
          <Route path='/expertise/architecture' element={<Architecture />} />
          <Route path='/expertise/climate-and-sustainable-design' element={<ClimateSustainableDesign />} />
          <Route path='/expertise/engineering' element={<Engineering />} />
          <Route path='/expertise/interiors' element={<Interiors />} />
          <Route path='/expertise/industrial-design' element={<IndustrialDesign />} />
          <Route path='/expertise/urban-and-landscape-design' element={<UrbanAndLandscapeDesign />} />
          <Route path='/expertise/workplace-consultancy' element={<WorkplaceConsultancy />} />

          <Route path='/projects' element={<Projects />} />
          <Route path='/projects/project-1' element={<Project1 />} />

          <Route path='/contact' element={<Contact />} />

          <Route path='/people' element={<People />} />
        </Routes>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
